import { Directive, effect, inject, input, TemplateRef, ViewContainerRef } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

import { TranslationStore } from '@rent2end/core/translation';

@Directive({
  selector: '[r2eValidationError]',
  standalone: true,
})
export class ValidationErrorDirective {
  private templateRef = inject(TemplateRef<unknown>);
  private translationStore = inject(TranslationStore);
  private viewContainerRef = inject(ViewContainerRef);
  
  r2eValidationErrorFrom = input.required<ValidationErrors | null>();

  constructor() {
    effect(() => {
      const errors = this.r2eValidationErrorFrom();

      this.viewContainerRef.clear();

      if (errors) {
        const errorKey = Object.keys(errors)[0];

        this.viewContainerRef.createEmbeddedView(this.templateRef, {
          $implicit: this.translationStore.translate(`COMMON.VALIDATION_ERROR_MESSAGES.${errorKey.toUpperCase()}`, errors[errorKey]),
        });
      }
    });
  }
}
